import React, { useEffect, useState } from "react";

const REACT_APP_API = process.env.REACT_APP_API_URL || "";

/**
 * SuggestionHistorique — historique legacy (table SUGGESTION_HISTORIQUE,
 * données réelles antérieures à l'app + nouvelles lignes écrites par
 * SuggestionHistoriqueListener), le plus récent en premier.
 */
export default function SuggestionHistorique({ sugId }) {
  const [lignes, setLignes] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sugId) return;
    fetch(`${REACT_APP_API}/api/custom/suggestions/${sugId}/historique`)
      .then((res) => res.json())
      .then((data) => setLignes(Array.isArray(data) ? data : []))
      .catch((e) => console.error("Erreur chargement historique", e));
  }, [sugId]);

  if (!sugId) return null;

  return (
    <div className="pb-3">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="btn fr-btn--secondary"
        style={{ marginBottom: open ? 10 : 0 }}
      >
        {open ? "▼" : "▶"} Historique{lignes ? ` (${lignes.length})` : ""}
      </button>

      {open && (
        lignes === null ? (
          <p style={{ fontSize: 13, color: "#9ca3af" }}>Chargement…</p>
        ) : lignes.length === 0 ? (
          <p style={{ fontSize: 13, color: "#9ca3af" }}>Aucun historique pour cette suggestion.</p>
        ) : (
          <div style={{ maxHeight: 220, overflowY: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, color: "white" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #4b5563", textAlign: "left" }}>
                  <th style={{ padding: "4px 8px" }}>Date</th>
                  <th style={{ padding: "4px 8px" }}>Action</th>
                  <th style={{ padding: "4px 8px" }}>Statut</th>
                  <th style={{ padding: "4px 8px" }}>Collège</th>
                </tr>
              </thead>
              <tbody>
                {lignes.map((l, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #374151" }}>
                    <td style={{ padding: "4px 8px", whiteSpace: "nowrap" }}>
                      {l.date ? new Date(l.date).toLocaleDateString("fr-FR") : "—"} {l.heure || ""}
                    </td>
                    <td style={{ padding: "4px 8px" }}>{l.nature || "—"}</td>
                    <td style={{ padding: "4px 8px" }}>
                      {l.staOrigine || l.staNouveau
                        ? `${l.staOrigine || "—"} → ${l.staNouveau || "—"}`
                        : "—"}
                    </td>
                    <td style={{ padding: "4px 8px" }}>{l.collegeCode || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
